module.exports = __webpack_public_path__ + "img/365-cd2ec5.png";